/* eslint-disable no-multi-spaces */
/**
 * Created by wjjn3481 on 2017/4/18.
 */
import axios from 'axios'

const baseFields = [
    'WB_EVALUATION_STATUS',
    'WB_PAYMENT_STATUS',
    'WB_SEND_STATUS',
    'WB_GENDER',                     // 性别
    'WB_EDU_DEGREE',                 // 学历
    'WB_ADD_SOURCE',                 // 简历投递渠道
    'WB_RESUME_SOURCE',              // 简历来源
    'WB_POSITION_CITY',              // 工作城市
    'WB_WORK_YEARS',                 // 工作年限
    'WB_ID_CARD_TYPE',               // 证件类型
    'WB_EXPECTED_SALARY',            // 期望薪酬
    'WB_COUNTRY_ALL',                // 国家集
    'WB_FLOW_STATUS',                // 流转状态对应
    'WB_RESUME_STATUS_0',            // 筛选
    'WB_RESUME_STATUS_1',            // 笔试
    'FLOW_STATUS_EMPLOY_TURN_TYPE',  // 面试
    'WB_RESUME_STATUS_6',            // 入职
    'WB_RESUME_STATUS_7',            // 入职
    'WB_PHASE',                      // 招聘阶段
    'WB_USER_ATTRIBUTES',            // 用户类型
    'WB_INTERVIEW_TYPE',             // 面试形式
    'WB_USER_VIEWPOINT',             // 面试建议
    'WB_JOB_TYPE',                   // 职位大类别
    'WB_JOB_POSITION_TYPE',          // 职位大类夹小类别
    'WB_SCORE_TYPE',                 // 职位评分标准
    'WB_PROPERTY_TYPE',              // 校招、社招类型
    'WB_POSITION_STATE',             // 职位状态
    'WB_SMS_SEND',                    // 邮件发送状态
    'WB_ACCEPT_REGULATE',
    'WB_INTERVIEW_STATUS',
    'YES_OR_NO',                      // 是或者否
    'WB_SOURCE_FROM',                 // 招聘来源
    'WB_RESUME_EXAM_STATUS',          // 考试状态
    'WB_RESUME_STATUS_1',             // 笔试状态
    'WB_SKILL_PROFICIENCY',           // 技能熟练度
    'WB_SKILL_YEARS',                 // 技能使用时间
    'PROVINCE_ALL',                   // 单独全部省份
    'CITY_ALL',                       // 单独全部城市
    'PROVINCE_ALL_WITH_CITY',         // 全部省份与城市
    'SCHOOL_TYPES',                   // 学校类型
    'SYNC_STATUS',                    // 同步供应商
    'WB_POSITION_SEQUENCE_ALL',       // 职位序列类型
    'WB_POSITION_SEQUENCE_JSON'       // 职位序列树状结构
]

// state
const state = {
    selectMap: {
        WB_RESUME_STATUS_INTERVIEW: []
    }
}

// actions
const actions = {
    FETCH_BASE_DATA({ commit, state }) {
        return axios.get('/share/getBasicData.api?BASE_DATA_KEY=' + baseFields.join(','), { 'X-loadingOff': false })
            .then((res) => commit('FETCH_BASE_DATA_SUCCESS', res))
            .catch((err) => commit('FETCH_BASE_DATA_FAIL', err))
    }
}

// mutations
const mutations = {
    FETCH_BASE_DATA_SUCCESS(state, res) {
        // 删掉多余字段
        delete res.result.signOut
        state.selectMap = res.result
        state.selectMap.WB_SCHOOL_LEVEL = [
            { text: '1档', value: '1' },
            { text: '2档', value: '2' },
            { text: '3档', value: '3' },
            { text: '4档', value: '4' }
        ]
    },
    UPDATE_SELECT_MAP_DATA(state, data) {
        Object.assign(state.selectMap, data)
    },
    FETCH_BASE_DATA_FAIL(state, err) {
    }
}

export default {
    state,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/baseData.js